import { render, staticRenderFns } from "./X-gestion-user.vue?vue&type=template&id=9c1ac930&scoped=true"
import script from "./X-gestion-user.vue?vue&type=script&lang=js"
export * from "./X-gestion-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1ac930",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c1ac930')) {
      api.createRecord('9c1ac930', component.options)
    } else {
      api.reload('9c1ac930', component.options)
    }
    module.hot.accept("./X-gestion-user.vue?vue&type=template&id=9c1ac930&scoped=true", function () {
      api.rerender('9c1ac930', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user/X-gestion-user.vue"
export default component.exports